import React from 'react';
import { Button } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { PatientsTable, PrivateLayout } from '../components';
import { FeatureGuard } from '../components/multi-tenant/FeatureGuard';
import { navigateToPatientsNew } from '../redux';
import { buttonBackgroundSelector } from '../redux/selectors/buttonBackground.selector';

export const PatientsView = () => {
  const dispatch = useDispatch();
  const renderButton = () => {
    const buttonBackgroundClass = useSelector(buttonBackgroundSelector);
    return (
      <FeatureGuard contentKey='patient-management.manage'>
        <Button
          className={buttonBackgroundClass}
          variant='secondary'
          size='sm'
          onClick={() => dispatch(navigateToPatientsNew())}
          data-testid='cmx__add-patient-button'>
          ADD A PATIENT
        </Button>
      </FeatureGuard>
    );
  };
  return (
    <PrivateLayout pageTitle='patients' subtoolbarChildren={renderButton()}>
      <PatientsTable enableExternalFilters />
    </PrivateLayout>
  );
};
